// Mock data for Etawah Lion Safari clone

export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Safari Park', to: '/safari' },
  { label: 'Animals', to: '/animals' },
  { label: 'Nearby Places', to: '/nearby' },
  { label: 'Tickets', to: '/tickets' },
  { label: 'Gallery', to: '/gallery' },
  { label: 'Contact', to: '/contact' },
];

export const heroImages = [
  'https://customer-assets-m6fa6gv7.emergentagent.net/job_etawah-lion-safari/artifacts/j3a5pl72_image.png',
  'https://images.unsplash.com/photo-1651663513258-1528b7b173d5?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1624951714070-74a95c1f6959?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1758144761779-fce83ad8b359?crop=entropy&cs=srgb&fm=jpg&q=85',
];

export const aboutInfo = {
  title: 'Welcome to Etawah Lion Safari',
  subtitle: "India's Largest Lion Safari Park",
  body: `Etawah Lion Safari is spread over an area of about 350 hectares along the Etawah–Gwalior road in Uttar Pradesh, India. Established with the noble intent of conserving the endangered Asiatic lion, the park houses lions, leopards, deer, bears, antelopes, and hundreds of species of birds in a semi-wild environment. Visitors enjoy a captivating safari drive through natural woodland, spotting the majestic lions in their natural habitat.`,
  stats: [
    { label: 'Hectares', value: '350+' },
    { label: 'Lions', value: '15+' },
    { label: 'Bird Species', value: '200+' },
    { label: 'Est. Year', value: '2014' },
  ],
};

export const animals = [
  {
    name: 'Asiatic Lion',
    scientific: 'Panthera leo persica',
    img: 'https://images.unsplash.com/photo-1758144761779-fce83ad8b359?crop=entropy&cs=srgb&fm=jpg&q=85',
    desc: 'The pride of Etawah Safari, the majestic Asiatic Lion roams freely in a dedicated 50-hectare enclosure.',
  },
  {
    name: 'Leopard',
    scientific: 'Panthera pardus',
    img: 'https://images.unsplash.com/photo-1544985361-b420d7a77043?crop=entropy&cs=srgb&fm=jpg&q=85',
    desc: 'Agile and elusive, our leopards can be seen resting on branches or stalking through the underbrush.',
  },
  {
    name: 'Spotted Deer',
    scientific: 'Axis axis',
    img: 'https://images.unsplash.com/photo-1578449430693-3c282b41499b?crop=entropy&cs=srgb&fm=jpg&q=85',
    desc: 'Graceful herds of chital roam freely across the herbivore safari zone, a delight for every visitor.',
  },
  {
    name: 'Sloth Bear',
    scientific: 'Melursus ursinus',
    img: 'https://images.unsplash.com/photo-1626717718625-cd004d986886?crop=entropy&cs=srgb&fm=jpg&q=85',
    desc: 'A shaggy-coated omnivore native to the Indian subcontinent, active around dusk and dawn.',
  },
  {
    name: 'Blackbuck',
    scientific: 'Antilope cervicapra',
    img: 'https://images.unsplash.com/photo-1551615577-1c7e180a77ac?crop=entropy&cs=srgb&fm=jpg&q=85',
    desc: "India's fastest antelope with striking spiral horns, thriving in our open grasslands.",
  },
  {
    name: 'Indian Leopard',
    scientific: 'Panthera pardus fusca',
    img: 'https://images.unsplash.com/photo-1629820133762-24189e3c2b13?crop=entropy&cs=srgb&fm=jpg&q=85',
    desc: 'The subcontinent\'s stealthy master of camouflage, often perched high in shady groves.',
  },
];

export const safariZones = [
  {
    title: 'Lion Safari',
    img: 'https://images.unsplash.com/photo-1651663513258-1528b7b173d5?crop=entropy&cs=srgb&fm=jpg&q=85',
    desc: 'A 50-hectare enclosure where you can witness the king of the jungle in its wild habitat.',
  },
  {
    title: 'Leopard Safari',
    img: 'https://images.unsplash.com/photo-1544985361-b420d7a77043?crop=entropy&cs=srgb&fm=jpg&q=85',
    desc: 'A separate reserve for spotting agile leopards among rocks and shaded trees.',
  },
  {
    title: 'Deer Safari',
    img: 'https://images.unsplash.com/photo-1578449430693-3c282b41499b?crop=entropy&cs=srgb&fm=jpg&q=85',
    desc: "Home to hundreds of chital, sambar, and blackbuck grazing across sweeping meadows.",
  },
  {
    title: 'Bear Safari',
    img: 'https://images.unsplash.com/photo-1626717718625-cd004d986886?crop=entropy&cs=srgb&fm=jpg&q=85',
    desc: 'Encounter the shy Indian sloth bear in a woodland habitat crafted for their well-being.',
  },
];

export const tickets = {
  indian: [
    { age: 'Above 12 years', nonAc: 250, ac: 375, theatre: 150, nonAcCombo: 300, acCombo: 400 },
    { age: '6 to 12 years', nonAc: 65, ac: 125, theatre: 100, nonAcCombo: 120, acCombo: 170 },
    { age: 'Below 6 years', nonAc: 'Free', ac: 'Free', theatre: 'Free', nonAcCombo: 'Free', acCombo: 'Free' },
  ],
  foreign: [
    { age: 'Above 12 years', nonAc: 625, ac: 1250, theatre: 400, nonAcCombo: 800, acCombo: 1300 },
    { age: '6 to 12 years', nonAc: 500, ac: 1000, theatre: 300, nonAcCombo: 600, acCombo: 1000 },
    { age: 'Below 6 years', nonAc: 'Free', ac: 'Free', theatre: 'Free', nonAcCombo: 'Free', acCombo: 'Free' },
  ],
};

export const timings = [
  { period: '1 April – 30 September', hours: '9:00 AM to 4:30 PM' },
  { period: '1 October – 31 March', hours: '9:00 AM to 4:00 PM' },
  { period: 'Weekly Off', hours: 'Every Monday Closed' },
];

export const galleryImages = [
  'https://upload.wikimedia.org/wikipedia/commons/1/14/Etawah_Safari_Park.jpg',
  'https://etawahlionsafari.org/Zoo_Admin/Gallery/1756827032.jpg',
  'https://etawahlionsafari.org/Zoo_Admin/Gallery/1176232689.jpg',
  'https://etawahlionsafari.org/Zoo_Admin/Gallery/347402436.jpg',
  'https://etawahlionsafari.org/Zoo_Admin/Gallery/148974850.jpg',
  'https://etawahlionsafari.org/Zoo_Admin/Gallery/673164286.jpg',
  'https://etawahlionsafari.org/Zoo_Admin/Gallery/1029144622.jpg',
  'https://etawahlionsafari.org/Zoo_Admin/Gallery/960618445.jpg',
  'https://etawahlionsafari.org/Zoo_Admin/Gallery/1999872859.jpg',
  'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/1e/9e/e2/da/view-of-etawah-lion-safari.jpg',
];

export const nearbyPlaces = [
  {
    category: 'Wildlife & Nature',
    name: 'Etawah Safari Park',
    distance: 'On-site',
    img: 'https://upload.wikimedia.org/wikipedia/commons/1/14/Etawah_Safari_Park.jpg',
    desc: 'A vast drive-through park on Gwalior Bypass Road featuring dedicated lion, leopard, tiger, bear and deer zones, along with a rich bird aviary.',
  },
  {
    category: 'Wildlife & Nature',
    name: 'National Chambal Sanctuary',
    distance: 'Near Udi, Etawah',
    img: 'https://images.unsplash.com/photo-1763879183886-02f94ad55880?crop=entropy&cs=srgb&fm=jpg&q=85',
    desc: 'A protected riverine reserve on the Chambal, ideal for spotting rare freshwater gharials, mugger crocodiles and Gangetic dolphins.',
  },
  {
    category: 'Wildlife & Nature',
    name: 'Pachnada – Confluence of Five Rivers',
    distance: '~40 km from Etawah',
    img: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_etawah-lion-safari/artifacts/uedthkb5_Pachnda.jpg',
    desc: 'A rare natural marvel where five rivers – Yamuna, Chambal, Kwari, Sindh and Pahuj – meet, creating vast sandbanks and a serene landscape loved by birdwatchers.',
  },
  {
    category: 'History & Landmarks',
    name: 'Raja Sumer Singh Fort',
    distance: 'Etawah city',
    img: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_etawah-lion-safari/artifacts/47imj3lm_Raja%20Sumer%20Singh%20Fort.jpg',
    desc: 'A historic fort on the banks of the Yamuna River, offering a glimpse of the region\u2019s royal past through weathered ramparts and courtyards.',
  },
  {
    category: 'Religious Sites',
    name: 'Kali Bahan Temple',
    distance: 'Etawah',
    img: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_etawah-lion-safari/artifacts/osb6z3kt_kali-bahan-mandir.jpg',
    desc: 'An ancient and deeply revered shrine of Goddess Kali, believed by devotees to date back to the mythological era of the Mahabharata.',
  },
  {
    category: 'Religious Sites',
    name: 'Tixi Temple',
    distance: 'Gwalior Road, Etawah',
    img: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_etawah-lion-safari/artifacts/gz7b3dtp_tixitemple_full.webp',
    desc: 'A well-known historic Lord Shiva temple on Gwalior Road, drawing pilgrims especially during Mahashivratri and the month of Shravan.',
  },
];


export const contact = {
  address: 'Etawah–Gwalior Road, Etawah, Uttar Pradesh, India – 206001',
  phone: '+91 8923493988',
  email: 'etawahlionsafari@gmail.com',
  mapEmbed:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3546.4!2d79.017!3d26.712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sEtawah%20Lion%20Safari!5e0!3m2!1sen!2sin!4v1700000000',
};

export const facilities = [
  { title: 'Guided Safari', icon: 'Compass', desc: 'Expert naturalists guide you through the park in eco-friendly vehicles.' },
  { title: '4D Theatre', icon: 'Film', desc: 'Immerse in wildlife stories brought to life with our state-of-the-art 4D theatre.' },
  { title: 'Interpretation Center', icon: 'BookOpen', desc: 'Learn about conservation, Asiatic lions, and biodiversity.' },
  { title: 'Food Court', icon: 'Utensils', desc: 'Enjoy delicious Indian meals & snacks after your safari adventure.' },
  { title: 'Souvenir Shop', icon: 'ShoppingBag', desc: 'Take home safari-themed memorabilia and gifts.' },
  { title: 'Ample Parking', icon: 'ParkingCircle', desc: 'Free spacious parking for cars, buses, and two-wheelers.' },
];
